export default {
    es: {
        not_tour_list: "Por el momento no tenemos tours disponibles",
        before_reservation: "Lo que debes saber antes de reservar",
        reservation_now: "Reserva tu aventura ahora",
        checkout_title: "Verificar datos",
        info_contact:" Información de contacto",
        check_summary: "Resumen de Compra",
        tasa: "Tasa servicio",
        total: "Total",
        contact_form: {
            card_title: "Nombre del tarjetahabiente",
            name_input:"*Nombre(s)",
            lastname_input: "*Primer apellido",
            surname_input: "*Segundo apellido",
            email_title: "Correo electrónico",
            email_input: "*La confirmación sera enviada a esta dirección",
            confirm_title: "Confirmar correo electrónico",
            confirm_input: "*Confirmación de correo electrónico",
            phone_title: "Número de Teléfono",
            payment_title: "Método de Pago",
        },
        passengers: {
            adult: "Adulto",
            adults: "Adultos",
            child: "Niño",
            children: "Niños",
            years: "años"
        },
        time: "Hora",
        select_time: "Selecciona un horario.",
        button: {
            reservation_now: "Reservar Ahora",
            continue: "Continuar",
            see_more: "Ver más...",
            meet_tour: "Ver más...",
        },
        payment: {
            mit: {
                title: "Una sola exhibición tarjeta de crédito o débito:" 
            },
            banamex: {
                title: "Una sola exhibición tarjeta de crédito o débito:" 
            },
        },
        alert: {
            error:{
                //Error Detail
                num_adults_invalid: "Número de pasajeros adultos, invalido",
                num_children_invalid: "Número de pasajeros niños, invalido",
                day_invalid: "Seleccione un día para realizar su tour",
                time_invalid: "Seleccione un horario para su tour",
                select_passengers: "Por favor, agrega almenos un pasajero a tu tour",
                num_adult_exceeded: "Número de pasajeros adultos excedido",
                num_children_exceeded: "Número de pasajeros niños excedido",
                passengers_exceeded: "Número de pasajeros excedido",

                //Error Checkout Form
                name: "El campo 'Nombre(s)' es requerido",
                lastname: "El campo 'Primer apellido' es requerido",
                surname: "El campo 'Segundo Apellido' es requerido",
                email: "El campo 'Correo Electrónico' es requerido",
                confirm_email: "El campo 'Confirmar correo electrónico' es requerido",
                country: "El campo 'Código de Pais' es requerido",
                cellphone: "El campo 'Número de Teléfono' es requerido",
                payment: "El campo 'Método de Pago' es requerido",
                email_not_same: "Los correos electronicos no coinciden",
                select_payment: 'Por favor, seleccione un método de pago',

                //Tour List
                error_empty_brand_id: "La Marca de consulta está vacía o no es válida",
                reservation_not_found: "No se ha encontrado ninguna reservación registrada con el código proporcionado",
                reservation_temporal: "El código proporcionado es de una reservación temporal",
                reservation_inactive: "El código proporcionado es de una reservación inactiva",
                tours_error_request: "Solicitud de listado de tours fallido",
                tours_not_found: "Listado de Tours vacío",
                unexpected_operative_source: "Fuente operativa invalida",
                booking_not_found: "Código de reservación de Vallarta Adventures no encontrado",
                booking_inactive: "Código de reservación de Vallarta Adventures invalido",
                error_empty_cashbox_id: "Identificador de caja de la fuente operativa es invalida",
                error_cashbox_user: "Usuario de caja no encontrado",
                error_cashbox_device: "Dispositivo de caja no encontrado",
                cashbox_not_found: "La caja asignada no se ha encontrado",
                cashbox_inactive: "La caja asignada se encuentra inactiva",
                cashbox_closed: "La caja asignada se encuentra cerrada",
                cannot_save_log: "No ha sido posible guardar registro de tour",
                database_error: {
                    title: 'Error al obtener la información',
                    detail: {
                        begin_transaction: "Error al obtener la información, iniciar transacción",
                        insert_tour_history: "Error al obtener la información, insertar historial de viaje",
                        insert_booking: "Error al obtener la información, insertar código de reservación de vallarta adventures",
                        commit_transaction: "Error al obtener la información, confirmar transacción",
                        insert_disposal: "Error al obtener la información, insertar eliminación",
                        insert_booking_sale: "Error al obtener la información, insertar boletos de venta en reservaciones",
                        insert_booking_payment: "Error al obtener la información, insertar el pago de reservación",
                        update_booking_payment: "Error al obtener la información, actualizar el pago de reservación"
                    }
                },
                error_proccess_request: 'Error al obtener la información',

                //Dates
                error_empty_booking_code: "El código de reservación de vallarta adventures se encuentra vacio o es invalido",
                error_empty_tour_id: "El código de tour se encuentra vacio o es invalido",
                error_empty_date: "La fecha de reservación de tour se encuentra vacia o es invalida",
                dates_error_request: "La solicitud de fechas para tour ha fallado",
                cannot_get_log: "No ha sido posible obtener el registro de tour",

                //Checkout(POST)
                error_empty_first_name: "El campo 'Nombre(s)' se encuntra vacio o es invalido",
                error_empty_last_name: "El campo 'Primer apellido' se encuntra vacio o es invalido",
                error_empty_second_surname: "El campo 'Segundo apellido' se encuntra vacio o es invalido",
                error_empty_email: "El campo 'Correo electrónico' se encuntra vacio o es invalido",
                error_empty_phone: "El campo 'Número de Teléfono' se encuntra vacio o es invalido",
                error_empty_time: "El horario de reservación de tour se encuentra vacio o es invalido",
                error_empty_payment_method: "El método de pago se encuentra vacio o es invalido",
                error_empty_total: "El costo total del tour se encuentra vacio o es invalido",
                unexpected_rate_types: "No se han seleccionado pasajero para el tour",
                tour_not_found: "No se ha encontrado el tour seleccionado",
                timeslot_not_found: "La Hora y Fecha seleccionadas no se encuentran disponibles",
                max_adult_exceeded: "Número de pasajeros adultos excedido",
                max_child_exceeded: "Número de pasajeros niños excedido",
                max_tickets_exceeded: "Número de pasajeros excedido",
                wrong_total: "EL precio total a pagar ha sido mal calculado",
                reserve_error_request: "Vallarta Adventures no ha permitido realizar la reservación",
                commit: "No se puede confirmar la transacción",
                //Banamex
                wrong_bank_config: "Error en la configuración del metodo de pago seleccionado",
                error_request_banamex: "Error en solicitud de sección del banco",

                //Checkout(PUT)
                error_empty_order_id: "El identificador de la orden de compra se encuentra vacio o es invalido",
                wrong_payment_attempt: "Los datos de pago son incorrectos",
                payment_attemp_not_found: "Los datos de pago no han encontrados",
                booking_error_request: "No ha sido posible insertar el historial del viaje",
                //MIT
                error_empty_device: "Dispositivo de MIT se encuentra vacio o es invalido",
                cannot_generate_url: "Error al generarl url para pago en MIT",

                //Checkout(GET)
                bank_answer_not_found: "Respuesta del banco no ha sido encontrada",
                problem_bank: "Problemas al procesar la informacion",
                process_bank: "No ha sido posible guardar el proceso",
                bank_rejected: 'No se pudo realizar el pago, transacción rechazada por el banco',

                //Tickets
                cannot_generate_ticket: "Error al generar ticket de compra para tours",

                empty_card_number_password: 'Por favor ingrese la tarjeta o celular y contraseña del viajero frecuente.',
                unrecognized_method: 'Método no reconocido',
                isnt_possible: 'No es posible continuar con la reservación',
                cancel_trasaction: 'Transaccion cancelada',
                
                check_payment: 'Conectando con el banco...',
                database_error_transaction: 'Error al obtener la información',
                title_error: "Error al obtener información del tour",
                ticket_error: "No se ha podido generar el ticket del tour",
                error_payment: "Error: datos de pago no reconocidos",
                error_empty_captcha: "Por favor seleccione la casilla 'No soy un robot'",
                error_captcha_not_found: "Validacion de google recaptcha invalida",
                
                //Alert redirect
                title: "¿Desea abandonar su compra?",
                title_ticket: "¿Desea abandonar su ticket de compra?",
                message: "Al aceptar automaticamente se perderá el/los tour(s) seleccionados.",
                message_ticket: "Al aceptar automaticamente se perderá la impresión de su ticket de compra de tours.",
                cancel: "ABANDONAR COMPRA",
                confirm: "CONTINUAR COMPRA",

                not_found: "Error al obtener la información"
            }
        }
    },
    en: {
        not_tour_list: "At the moment we don't have tours available",
        before_reservation: "What you should know before booking",
        reservation_now: "Book your adventure now",
        checkout_title: "Check data",
        info_contact:"Contact information",
        check_summary: "Purchase Summary",
        tasa: "Service rate",
        total: "Total",
        contact_form: {
            card_title: "Cardholder Name",
            name_input:"*Name(s)",
            lastname_input: "*First Last Name",
            surname_input: "*Middle surname",
            email_title: "Email",
            email_input: "*Confirmation will be sent to this address",
            confirm_title: "Confirm email",
            confirm_input: "*Email Confirmation",
            phone_title: "Phone Number",
            payment_title: "Payment Method",
        },
        passengers: {
            adult: "Adult",
            adults: "Adults",
            child: "Child",
            children: "Children",
            years: "years"
        },
        time: "Time",
        select_time: "Select a time.",
        button: {
            reservation_now: "Book Now",
            continue: "Continue",
            see_more: "See more...",
            meet_tour: "See more...",
        },
        payment: {
            mit: {
                title: "A single showing credit or debit card:"
            },
            banamex: {
                title: "A single showing credit or debit card:"
            },
        },
        alert: {
            error:{
                //ErrorDetail
                num_adults_invalid: "Number of adult passengers, invalid",
                num_children_invalid: "Number of child passengers, invalid",
                day_invalid: "Select a day for your tour",
                time_invalid: "Select a time for your tour",
                select_passengers: "Please add at least one passenger to your tour",
                num_adult_exceeded: "Number of adult passengers exceeded",
                num_children_exceeded: "Number of children passengers exceeded",
                passengers_exceeded: "Number of passengers exceeded",

                //Error Checkout Form
                name: "The field 'Name(s)' is required",
                lastname: "The 'First Last Name' field is required",
                surname: "The field 'Middle Surname' is required",
                email: "The 'Email' field is required",
                confirm_email: "The 'Confirm Email' field is required",
                country: "The 'Country Code' field is required",
                cellphone: "The 'Phone Number' field is required",
                payment: "The 'Payment Method' field is required",
                email_not_same: "Emails do not match",
                select_payment: 'Please select a payment method',
                
                //TourList
                error_empty_brand_id: "Query Brand is empty or invalid",
                reservation_not_found: "No reservation registered with the provided code was found",
                reservation_temporal: "The code provided is for a temporary reservation",
                reservation_inactive: "The code provided is for an inactive reservation",
                tours_error_request: "Tour listing request failed",
                tours_not_found: "Empty Tour List",
                unexpected_operative_source: "Invalid operational source",
                booking_not_found: "Vallarta Adventures reservation code not found",
                booking_inactive: "Vallarta Adventures reservation code invalid",
                error_empty_cashbox_id: "Cashbox identifier of the operational source is invalid",
                error_cashbox_user: "Cashbox user not found",
                error_cashbox_device: "Cashbox device not found",
                cashbox_not_found: "The allocated box was not found",
                cashbox_inactive: "The assigned box is inactive",
                cashbox_closed: "The assigned box is closed",
                cannot_save_log: "Could not save tour log",
                database_error: {
                    title: 'Error getting the information',
                    detail: {
                        begin_transaction: "Error getting information, start transaction",
                        insert_tour_history: "Error getting information, insert tour history",
                        insert_booking: "Error getting information, insert vallarta adventures reservation code",
                        commit_transaction: "Error getting information, commit transaction",
                        insert_disposal: "Error getting info, insert disposal",
                        insert_booking_sale: "Error getting information, insert sales tickets into reservations",
                        insert_booking_payment: "Error getting information, insert reservation payment",
                        update_booking_payment: "Error getting information, update reservation payment"
                    }
                },
                error_process_request: 'Error getting information',

                //Dates
                error_empty_booking_code: "The vallarta adventures reservation code is empty or invalid",
                error_empty_tour_id: "The tour code is empty or invalid",
                error_empty_date: "The tour reservation date is empty or invalid",
                dates_error_request: "Request dates for tour has failed",
                cannot_get_log: "Could not get tour log",

                //Checkout(POST)
                error_empty_first_name: "Field 'Name(s)' is empty or invalid",
                error_empty_last_name: "The field 'First last name' is empty or invalid",
                error_empty_second_surname: "The 'Second Surname' field is empty or invalid",
                error_empty_email: "The field 'Email' is empty or invalid",
                error_empty_phone: "The field 'Phone Number' is empty or invalid",
                error_empty_time: "The tour reservation time is empty or invalid",
                error_empty_payment_method: "The payment method is empty or invalid",
                error_empty_total: "The total cost of the tour is empty or invalid",
                unexpected_rate_types: "No passenger selected for the tour",
                tour_not_found: "The selected tour was not found",
                timeslot_not_found: "The selected Time and Date are not available",
                max_adult_exceeded: "Number of adult passengers exceeded",
                max_child_exceeded: "Number of child passengers exceeded",
                max_tickets_exceeded: "Number of passengers exceeded",
                wrong_total: "The total price to pay has been wrongly calculated",
                reserve_error_request: "Vallarta Adventures has not allowed the reservation to be made",
                commit: "Unable to commit transaction",
                //Banamex
                wrong_bank_config: "Error in the configuration of the selected payment method",
                error_request_banamex: "Error in bank section request",

                //Checkout(PUT)
                error_empty_order_id: "The identifier of the purchase order is empty or invalid",
                wrong_payment_attempt: "The payment data is incorrect",
                payment_attemp_not_found: "Payment data not found",
                booking_error_request: "Unable to insert trip history",
                //MIT
                error_empty_device: "MIT device is empty or invalid",
                cannot_generate_url: "Error generating url for payment at MIT",

                //Checkout(GET)
                bank_answer_not_found: "Bank answer not found",
                problem_bank: "Problems processing information",
                process_bank: "Could not save process",
                bank_rejected: 'Cannot complete the payment, transaction rejected by bank',

                //Tickets
                cannot_generate_ticket: "Error generating purchase ticket for tours",

                empty_card_number_password: 'Please enter frequent flyer card or cell phone number and password.',
                unrecognized_method: 'Unrecognized method',
                isnt_possible: 'It is not possible to continue with the reservation',
                cancel_trasaction: 'Transaction cancelled',
                
                check_payment: 'Connecting with bank...',
                database_error_transaction: 'Error getting data',
                title_error: "Error getting tour information",
                ticket_error: "Could not generate tour ticket",
                error_payment: "Error: unrecognized payment details",

                //Alert redirect
                title: "Do you want to abandon your purchase?",
                title_ticket: "Do you want to abandon your purchase ticket?",
                message: "Accepting automatically will lose the selected tour(s).",
                message_ticket: "By automatically accepting you will lose the printing of your tour purchase ticket.",
                cancel: "CANCEL PURCHASE",
                confirm: "CONTINUE PURCHASE",

                not_found: "Error getting information"

            }
        }
    }
}